import React, { useContext, useEffect } from "react";
import StoreContext from "@/context/root-store";
import { observer } from "mobx-react";
import TiTroviIn from "@/widget/TiTroviIn";
// @ts-ignore
import LogoParita from "../../../img/logoheaderpage.png";
import "../../../../css/Faq.css";
import imgTerritoriale from "../../../img/numeri/territoriale.png";
import imgLegenda from "../../../img/numeri/legenda.png";
import imgIta from "../../../img/numeri/distribuzioneItalia.png";
import imgAteco from "../../../img/numeri/codiceAteco.png";
import fileEstrattoAccredia from "../../../img/numeri/EstrattoAccredia.pdf";
var Numeri = observer(function (_props) {
  var rootStore = useContext(StoreContext).rootStore;
  var BREADCRUMB_TITOLO = "Numeri";
  var BREADCRUMB_CHILDREN = [{
    to: process.env.CONTEXT_PATH + "/home",
    label: "Home"
  }];
  var breadcrumb = /*#__PURE__*/React.createElement(TiTroviIn, {
    children: BREADCRUMB_CHILDREN,
    title: BREADCRUMB_TITOLO
  });

  // eslint-disable-next-line @typescript-eslint/no-var-requires
  var $ = require("jquery");
  useEffect(function () {
    document.title = "Certificazione della parità di genere - Numeri";
    $("#ita.list-inline-item").addClass("active");
    $("#eng.list-inline-item").removeClass("active");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (rootStore.uiStore.numberCallback !== 0) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "postizioneLogoHeader"
  }, /*#__PURE__*/React.createElement("img", {
    src: LogoParita,
    alt: "Logo parit\xE0 di genere",
    className: "img-fluid dimImage",
    width: "500"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-0"
  }, breadcrumb, /*#__PURE__*/React.createElement("div", {
    className: "row altezzaMin"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("h2", null, "Numeri"), /*#__PURE__*/React.createElement("p", null, "In questa sezione sono presentati i principali dati relativi alla diffusione della certificazione della parit\xE0 di genere: il numero complessivo di organizzazioni certificate, la distribuzione territoriale e la ripartizione per dimensione aziendale e settore economico."))))), /*#__PURE__*/React.createElement("div", {
    className: "coopycolor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4 mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement("strong", null, "Diffusione della Certificazione della Parit\xE0 di Genere")), /*#__PURE__*/React.createElement("p", null, "Questa sezione mostra lo stato di avanzamento della diffusione della certificazione della parit\xE0 di genere. Il numero delle organizzazioni certificate \xE8 estrapolato dalla", " ", /*#__PURE__*/React.createElement("strong", null, "banca dati Accredia"), ", Ente nazionale di accreditamento, e si riferisce alle organizzazioni certificate considerate sulla base della sede legale. Nel numero complessivo non sono conteggiate le sedi operative afferenti alla medesima partita IVA/codice fiscale. Dal file Excel scaricabile in basso \xE8 possibile ricavare i dati relativi alle organizzazioni certificate, tra cui il riferimento alla provincia della sede legale. Per ulteriori dati sulle certificazioni \xE8 possibile consultare la specifica sezione della banca dati Accredia:", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://services.accredia.it/ppsearch/accredia_companymask_remote.jsp?ID_LINK=1739&area=310",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "banca dati"), "."))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card my-3 d-flex justify-content-center align-items-center mt-5 mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-slider-article-container-dati mb-2"
  }, /*#__PURE__*/React.createElement("article", {
    className: "card card-default custom-slider-article card-image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body card-title-custom-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-100 text-center mt-3 mb-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "card-title card-title-custom-dati"
  }, "Organizzazioni Certificate"), /*#__PURE__*/React.createElement("h1", {
    className: "d-flex justify-content-center align-items-center mt-3 mb-3 organizzazioni-certificate-copy-style"
  }, "15.295")), /*#__PURE__*/React.createElement("div", {
    className: "ml-2 mt-3"
  }, /*#__PURE__*/React.createElement("a", {
    href: fileEstrattoAccredia,
    target: "_blank",
    rel: "noreferrer",
    style: {
      display: "inline-block"
    }
  }, "Visualizza la lista"))))))))), /*#__PURE__*/React.createElement("div", {
    className: "bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4 mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row lightblue-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("strong", null, "Dati disponibili per le analisi statistiche")), /*#__PURE__*/React.createElement("p", null, "I dati riportati nelle sezioni sottostanti si riferiscono ad un", " ", /*#__PURE__*/React.createElement("strong", null, "campione"), " delle organizzazioni certificate, per le quali \xE8 stato possibile reperire ulteriori informazioni rispetto ai dati contenuti nella banca dati pubblica Accredia. Si tratta di dati sulla dimensione, territorialit\xE0 e codice ATECO di appartenenza, caricati dagli organismi di certificazione accreditati, ai sensi della Circolare Accredia n. 43 del 12 dicembre 2022."))), /*#__PURE__*/React.createElement("div", {
    className: "row lightblue-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card my-3 d-flex justify-content-center align-items-center mt-5 mb-5 lightblue-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-slider-article-container-dati-analizzati mb-2"
  }, /*#__PURE__*/React.createElement("article", {
    className: "card card-default custom-slider-article card-image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body card-title-custom-container"
  }, /*#__PURE__*/React.createElement("p", {
    className: "card-title card-title-custom-dati"
  }, "Organizzazioni Certificate analizzate"), /*#__PURE__*/React.createElement("h1", {
    className: "d-flex justify-content-center align-items-center mt-3 mb-3 organizzazioni-certificate-copy-style"
  }, "5451")))))))), /*#__PURE__*/React.createElement("div", {
    className: "coopycolor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4 mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 p-3"
  }, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement("strong", null, "Analisi per Dimensione Aziendale")), /*#__PURE__*/React.createElement("p", {
    className: "mt-3"
  }, "La sezione illustra, in relazione al ", /*#__PURE__*/React.createElement("strong", null, "campione disponibile"), ", la ripartizione delle organizzazioni che hanno ottenuto la certificazione di parit\xE0 di genere, in base alla loro dimensione aziendale. L\u2019analisi fa riferimento alla classificazione dimensionale di cui alla Prassi UNI/PdR 125:2022 che distingue le imprese in micro, piccole, medie e grandi in base al numero degli addetti.")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-slider-article-container-dati-torta mb-2"
  }, /*#__PURE__*/React.createElement("article", {
    className: "card card-default custom-slider-article card-image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body card-title-custom-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: imgTerritoriale,
    alt: "Ripartizione delle organizzazioni certificate per dimensione aziendale",
    className: "img-fluid mx-auto m-img d-block",
    style: {
      maxWidth: "100%",
      height: "auto",
      objectFit: "contain"
    }
  }))))))))))), /*#__PURE__*/React.createElement("div", {
    className: "bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4 mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row lightblue-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("strong", null, "Distribuzione Territoriale delle Organizzazioni Certificate")), /*#__PURE__*/React.createElement("p", null, "La sezione rappresenta la diffusione territoriale della certificazione della parit\xE0 di genere, in relazione al ", /*#__PURE__*/React.createElement("strong", null, "campione disponibile"), ", con dettaglio per macroarea geografica. La presente analisi territoriale, differentemente da quella effettuata su dati estrapolati dalla banca dati Accredia, \xE8 realizzata ai soli fini statistici nell'ambito di un confronto con le altre variabili allo studio sul\xA0campione."), /*#__PURE__*/React.createElement("div", {
    className: "row mt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-slider-article-container-dati-mappa mb-2"
  }, /*#__PURE__*/React.createElement("article", {
    className: "card card-default custom-slider-article card-image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body card-title-custom-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: imgIta,
    alt: "Distribuzione territoriale delle organizzazioni certificate in Italia",
    className: "img-fluid mx-auto m-img d-block",
    style: {
      maxWidth: "100%",
      height: "auto",
      objectFit: "contain"
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-slider-article-container-dati-mappa mb-2"
  }, /*#__PURE__*/React.createElement("article", {
    className: "card card-default custom-slider-article card-image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body card-title-custom-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center mb-4"
  }, /*#__PURE__*/React.createElement("img", {
    src: imgLegenda,
    alt: "Legenda della distribuzione territoriale",
    className: "img-fluid mx-auto m-img d-block",
    style: {
      maxWidth: "100%",
      height: "auto",
      objectFit: "contain"
    }
  }))))))))))), /*#__PURE__*/React.createElement("div", {
    className: "coopycolor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4 mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement("strong", null, "Distribuzione delle Organizzazioni Certificate per Settore Economico")), /*#__PURE__*/React.createElement("p", null, "La sezione presenta la ripartizione delle organizzazioni che hanno ottenuto la certificazione di parit\xE0 di genere, in relazione al ", /*#__PURE__*/React.createElement("strong", null, "campione"), " ", "disponibile, suddivise per settore economico secondo la classificazione ATECO."), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card my-3 mt-3 mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("article", {
    className: "card card-default custom-slider-article card-image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body card-title-custom-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: imgAteco,
    alt: "Ripartizione delle organizzazioni certificate per settore economico (ATECO)",
    className: "img-fluid mx-auto m-img d-block",
    style: {
      maxWidth: "100%",
      height: "auto",
      objectFit: "contain"
    }
  }))))))))))));
});
export default Numeri;